import { z } from 'zod';
const EmailAddress = z.string().trim().email().max(320);
export const SetSalesMailAccountRequestSchema = z
    .object({
    email: EmailAddress,
    imapHost: z.string().trim().min(1).max(255),
    imapPort: z.coerce.number().int().min(1).max(65535),
    smtpHost: z.string().trim().min(1).max(255),
    smtpPort: z.coerce.number().int().min(1).max(65535),
    appPassword: z.string().trim().min(1).max(500),
    useTls: z.boolean().optional(),
})
    .strict();
export const SalesMailQuerySchema = z
    .object({
    folder: z.enum(['inbox', 'sent']).optional(),
    search: z.string().trim().max(200).optional(),
    limit: z.coerce.number().int().min(1).max(200).optional(),
})
    .strict();
/** Manual compose from the CRM → Mail tab (not the AI draft flow). */
export const SendSalesMailRequestSchema = z
    .object({
    to: EmailAddress,
    subject: z.string().trim().min(1).max(400),
    bodyHtml: z.string().trim().min(1).max(500_000),
    /** Optional — tags the sent row so a lead's thread shows it. */
    leadId: z.string().uuid().optional(),
})
    .strict();
export const SalesMailIdParamSchema = z.object({ id: z.string().uuid() });
export const UpdateSalesMailDraftRequestSchema = z
    .object({
    subject: z.string().trim().min(1).max(400).optional(),
    bodyHtml: z.string().max(500_000).optional(),
})
    .refine((d) => Object.keys(d).length > 0, {
    message: 'Provide subject and/or bodyHtml',
});
//# sourceMappingURL=sales.schema.js.map